<template>
    <div>
        <ResetPasswordComponent/>
    </div>
</template>

<script>
import ResetPasswordComponent from "@/components/LoginComponents/ResetPasswordComponent";

export default {
    components: {ResetPasswordComponent},
    title: 'ResetPassword'
}
</script>
